var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("el-cascader", {
        style: { display: _vm.display, width: "100%" },
        attrs: {
          size: _vm.size,
          placeholder: _vm.placeholder,
          options: _vm.options,
          props: { multiple: _vm.multiple, label: _vm.name, value: _vm.code },
          "collapse-tags": _vm.collapseTags,
          filterable: _vm.filterable,
          disabled: _vm.disabled,
          clearable: "",
        },
        on: { change: _vm.changeCascader },
        model: {
          value: _vm.localValue,
          callback: function ($$v) {
            _vm.localValue = $$v
          },
          expression: "localValue",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }